export const pickupMeliMe = {
    user: 'string',
    providerUserId: 0,
    ordersCreated: 10,
};

export const pickupShopifyMe = {
    user: 'string',
    providerUserId: 0,
    ordersCreated: 15,
    provider: 'string',
};

export const deliveriesTiendaNubeMe = {
    user: 'string',
    providerUserId: 0,
    ordersCreated: 15,
    provider: 'string',
};

export const carriersMeTiendaNubeMe = [
    { id: 'caba', name: 'CABA + Norte a 24hs hábiles' },
    { id: 'correo_custom', name: 'Correo custom' },
];
